export class FilterRequest {
    /**Id de categoría */
    public categoryList?: number[];
    /**Id de subcategoría */
    public subCategoryList?: number[];
    /**Id de marca */
    public brandList?: number[];
    /**Id de sección */
    public sectionList?: number[];
    /**Precio mínimo */
    public minPrice?: number;
    /**Precio máximo */
    public maxPrice?: number;
    /**Tipo de ordenamiento */
    public sortMode: string;
    /**Tamaño de página */
    public pageSize: number;
    /**Página */
    public page: number;
}